<!-- 提示弹框 -->
<template>
  <van-dialog
    v-model="show"
    :title="$t('global.dialog.title')"
    :message="info"
    :showConfirmButton="canclose"
    :confirmButtonText="$t('global.dialog.confirm')"
    :cancelButtonText="$t('global.dialog.cancel')"
    :confirmButtonColor="'var(--bgColor)'"
    @confirm="wannaCloseDialog"
  >
  </van-dialog>
</template>

<script>
import Vue from 'vue'
import {
  Dialog
} from 'vant'
Vue.use(Dialog)

export default {
  name: 'CusDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: '温馨提示'
    },
    canclose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },

  components: {},

  methods: {
    wannaCloseDialog() {
      this.$emit('listenCloseDialog')
    }
  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
</style>